import {riverGeneralSituactionApi} from 'api'

export const RIVERGENERALSITUACTION = 'RIVERGENERALSITUACTION'

export const riverGeneralSituationAction = (data) => ({
        type: RIVERGENERALSITUACTION,
        payload: {
            promise: riverGeneralSituactionApi.riverGeneralSituactionList(data)
        }
    })